import { ListItem, ListItemProps } from '@mui/material';
import * as React from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';

interface Props extends ListItemProps {
    pathname: string;
    state?: object;
    className?: string;
}

export default function NavLinkListItem({ pathname, state, className, ...listItemProps }: Props) {
    const NavLink = React.useMemo(
        () =>
            React.forwardRef<HTMLAnchorElement, Omit<RouterLinkProps, 'to'>>((props, ref) => (
                <RouterLink
                    ref={ref}
                    to={{
                        pathname: pathname,
                        state: state || {},
                    }}
                    {...props}
                />
            )),
        [pathname, state],
    );

    return (
        <ListItem component={NavLink as any} className={className} {...listItemProps}>
            {listItemProps.children}
        </ListItem>
    );
}
